(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-banner-grid-with-banner"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // ====== ADDED: tablet-only banner interval fix (9 desktop/mobile, 8 tablet) ======
  function MW_isTablet() {
    return window.matchMedia('(min-width: 750px) and (max-width: 989px)').matches;
  }

  function MW_getGridList(container) {
    // tenta encontrar o UL/GRID real onde estão os <li>
    return (
      container.querySelector('.product-grid') ||
      container.querySelector('#ProductGridContainer .product-grid') ||
      container.querySelector('#ProductGridContainer ul') ||
      container.querySelector('ul') ||
      container.querySelector('.grid')
    );
  }

  function MW_applyBannerInterval() {
    const container = document.getElementById('ProductGridContainer');
    if (!container) return;

    // guarda sempre o HTML "original" (Liquid = 9 em 9) assim que houver conteúdo
    // e antes de mexer nele
    if (!container.dataset.mwOriginalHtml) {
      container.dataset.mwOriginalHtml = container.innerHTML;
    }

    const tablet = MW_isTablet();

    // Se não for tablet: garantir que está no original (9 em 9)
    if (!tablet) {
      if (container.dataset.mwOriginalHtml && container.innerHTML !== container.dataset.mwOriginalHtml) {
        container.innerHTML = container.dataset.mwOriginalHtml;
      }
      return;
    }

    // Se for tablet: partir sempre do original e depois rearranjar para 8 em 8
    if (container.dataset.mwOriginalHtml) {
      container.innerHTML = container.dataset.mwOriginalHtml;
    }

    const list = MW_getGridList(container);
    if (!list) return;

    const children = Array.from(list.children);

    // Banners existentes (gerados pelo Liquid a cada 9)
    const banners = children.filter((el) =>
      el.classList && el.classList.contains('product-grid__item--banner')
    );

    if (banners.length === 0) return;

    // Remove banners do sítio original
    banners.forEach((b) => b.remove());

    // Produtos (sem banners)
    const products = Array.from(list.children).filter((el) =>
      el.classList && el.classList.contains('product-grid__item') && !el.classList.contains('product-grid__item--banner')
    );

    // Inserir os banners disponíveis a cada 8 produtos (tablet)
    const interval = 8;
    let bannerIdx = 0;

    for (let i = interval; i <= products.length; i += interval) {
      if (bannerIdx >= banners.length) break;
      const anchor = products[i - 1];
      anchor.insertAdjacentElement('afterend', banners[bannerIdx]);
      bannerIdx += 1;
    }
  }

  // Debounce leve para resize
  function MW_debounce(fn, wait) {
    let t;
    return function () {
      clearTimeout(t);
      t = setTimeout(() => fn(), wait);
    };
  }
  // ====== END ADDED ======

  document.addEventListener('DOMContentLoaded', function() {
    
    // CACHE SELECTORS
    const searchInput = document.getElementById('CollectionAjaxSearch');
    const sortSelect = document.getElementById('SortBy');
    const productGridContainer = document.getElementById('ProductGridContainer');
    const sectionElement = document.querySelector('[section-id]');
    const sectionId = sectionElement ? sectionElement.getAttribute('section-id') : '{{ section.id }}';

    // DEBOUNCE TIMER (Prevents spamming server while typing)
    let debounceTimer;

    // 1. MAIN FETCH FUNCTION
    function fetchAndRender(url) {
      // Ensure section_id is attached to get just this section's HTML
      const fetchUrl = new URL(url, window.location.origin);
      fetchUrl.searchParams.set('section_id', sectionId);

      if(productGridContainer) productGridContainer.style.opacity = '0.5';

      fetch(fetchUrl)
        .then(response => response.text())
        .then(responseText => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const newGrid = html.getElementById('ProductGridContainer');
          
          if (newGrid && productGridContainer) {
            productGridContainer.innerHTML = newGrid.innerHTML;
            productGridContainer.style.opacity = '1';

            // ADDED: reset original snapshot after AJAX render (Liquid = 9 em 9)
            productGridContainer.dataset.mwOriginalHtml = productGridContainer.innerHTML;
            MW_applyBannerInterval();

            // Only update Browser History if NOT searching (keeps back button clean)
            if (!fetchUrl.pathname.includes('/search')) {
               window.history.pushState({ path: url.toString() }, '', url.toString());
            }
          }
        })
        .catch(err => {
            console.error('Error fetching data:', err);
            if(productGridContainer) productGridContainer.style.opacity = '1';
        });
    }

    // 2. SERVER-SIDE SEARCH FUNCTION
    function performSearch() {
      const term = searchInput.value.trim();
      
      // If empty, go back to original collection URL
      if (term === "") {
         // Reset to basic collection URL (remove search params)
         const collectionUrl = new URL(window.location.pathname, window.location.origin);
         // Keep sort if it exists
         if(sortSelect) collectionUrl.searchParams.set('sort_by', sortSelect.value);
         fetchAndRender(collectionUrl);
         return;
      }

      // Construct Search URL
      // We search for 'product' type specifically
      const searchUrl = `/search?q=${encodeURIComponent(term)}&type=product`;
      fetchAndRender(searchUrl);
    }

    // 3. EVENT LISTENERS
    
    // Search Input (Debounced)
    if (searchInput) {
      searchInput.addEventListener('input', function() {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(performSearch, 300); // Wait 300ms after typing stops
      });
    }

    // Sort Select
    if (sortSelect) {
      sortSelect.addEventListener('change', function(e) {
        // Check if we are currently searching or viewing collection
        const term = searchInput ? searchInput.value.trim() : "";
        
        if (term !== "") {
           // Sort within search results
           const searchUrl = `/search?q=${encodeURIComponent(term)}&type=product&sort_by=${e.target.value}`;
           fetchAndRender(searchUrl);
        } else {
           // Sort within collection
           const url = new URL(window.location.href);
           url.searchParams.set('sort_by', e.target.value);
           fetchAndRender(url.toString());
        }
      });
    }

    // Pagination Click (Delegation)
    if (productGridContainer) {
      productGridContainer.addEventListener('click', function(e) {
        const link = e.target.closest('.ajax-pagination-btn');
        if (link) {
          e.preventDefault();
          fetchAndRender(link.href);
          
          // Scroll to top of grid
          productGridContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }

    // ADDED: apply on first load + on resize (only tablet changes)
    if (productGridContainer) {
      productGridContainer.dataset.mwOriginalHtml = productGridContainer.innerHTML;
      MW_applyBannerInterval();
      window.addEventListener('resize', MW_debounce(MW_applyBannerInterval, 150));
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-rsvp-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const openBtn = document.getElementById('openRsvpPopup');
    const closeBtn = document.getElementById('closeRsvpPopup');
    const popup = document.getElementById('rsvpPopup');

    if (openBtn && closeBtn && popup) {
      openBtn.addEventListener('click', () => {
        popup.classList.add('active');
      });

      closeBtn.addEventListener('click', () => {
        popup.classList.remove('active');
      });

      // Close popup if user clicks on the overlay background
      popup.addEventListener('click', (event) => {
        if (event.target === popup) {
          popup.classList.remove('active');
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["famm-hero-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const openBtn = document.getElementById('openRsvpPopup');
    const closeBtn = document.getElementById('closeRsvpPopup');
    const popup = document.getElementById('rsvpPopup');

    if (openBtn && closeBtn && popup) {
      openBtn.addEventListener('click', () => {
        popup.classList.add('active');
      });

      closeBtn.addEventListener('click', () => {
        popup.classList.remove('active');
      });

      // Close popup if user clicks on the overlay background
      popup.addEventListener('click', (event) => {
        if (event.target === popup) {
          popup.classList.remove('active');
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('DOMContentLoaded', function() {

    // CACHE SELECTORS
    const searchInput = document.getElementById('CollectionAjaxSearch');
    const sortSelect = document.getElementById('SortBy');
    const productGridContainer = document.getElementById('ProductGridContainer');
    const sectionElement = document.querySelector('[section-id]');
    const sectionId = sectionElement ? sectionElement.getAttribute('section-id') : '{{ section.id }}';

    // DEBOUNCE TIMER (Prevents spamming server while typing)
    let debounceTimer;

    // Aleatorizar a ordem dos banners (lê o pool JSON e baralha)
    function shuffleBanners() {
      var el = document.getElementById('cafe-banner-pool');
      if (!el) return;
      var pool;
      try { pool = JSON.parse(el.textContent); } catch (e) { return; }
      if (!pool || !pool.length) return;
      var imgs = document.querySelectorAll('#ProductGridContainer .product-grid__item--banner img');
      if (!imgs.length) return;
      for (var k = pool.length - 1; k > 0; k--) { var j = Math.floor(Math.random() * (k + 1)); var t = pool[k]; pool[k] = pool[j]; pool[j] = t; }
      for (var i = 0; i < imgs.length; i++) { imgs[i].src = pool[i % pool.length]; }
    }

    // Baralhar produtos só na vista por defeito (respeita o Sort by e a pesquisa)
    function productsShouldShuffle(u) {
      try {
        var url = new URL(u || window.location.href, window.location.origin);
        if (url.searchParams.get('sort_by')) return false;
        if (url.pathname.indexOf('/search') !== -1 || url.searchParams.get('q')) return false;
        return true;
      } catch (e) { return true; }
    }
    function shuffleProducts(u) {
      if (!productsShouldShuffle(u)) return;
      var anyItem = document.querySelector('#ProductGridContainer .product-grid__item');
      if (!anyItem) return;
      var grid = anyItem.parentElement;
      if (!grid) return;
      var children = Array.prototype.slice.call(grid.children);
      var products = children.filter(function (el) {
        return el.classList && el.classList.contains('product-grid__item') && !el.classList.contains('product-grid__item--banner');
      });
      if (products.length < 2) return;
      for (var i = products.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = products[i]; products[i] = products[j]; products[j] = t; }
      var k = 0;
      var finalOrder = children.map(function (el) {
        if (el.classList && el.classList.contains('product-grid__item') && !el.classList.contains('product-grid__item--banner')) { return products[k++]; }
        return el;
      });
      requestAnimationFrame(function () { finalOrder.forEach(function (el) { grid.appendChild(el); }); });
    }

    // 1. MAIN FETCH FUNCTION
    function fetchAndRender(url) {
      // Ensure section_id is attached to get just this section's HTML
      const fetchUrl = new URL(url, window.location.origin);
      fetchUrl.searchParams.set('section_id', sectionId);

      if (productGridContainer) productGridContainer.style.opacity = '0.5';

      fetch(fetchUrl)
        .then(response => response.text())
        .then(responseText => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const newGrid = html.getElementById('ProductGridContainer');

          if (newGrid && productGridContainer) {
            productGridContainer.innerHTML = newGrid.innerHTML;
            shuffleBanners();
            shuffleProducts(url);
            productGridContainer.style.opacity = '1';

            // Only update Browser History if NOT searching (keeps back button clean)
            if (!fetchUrl.pathname.includes('/search')) {
              window.history.pushState({ path: url.toString() }, '', url.toString());
            }
          }
        })
        .catch(err => {
          console.error('Error fetching data:', err);
          if (productGridContainer) productGridContainer.style.opacity = '1';
        });
    }

    // 2. SERVER-SIDE SEARCH FUNCTION
    function performSearch() {
      const term = searchInput.value.trim();

      // If empty, go back to original collection URL
      if (term === "") {
        // Reset to basic collection URL (remove search params)
        const collectionUrl = new URL(window.location.pathname, window.location.origin);
        // Keep sort if it exists
        if (sortSelect) collectionUrl.searchParams.set('sort_by', sortSelect.value);
        fetchAndRender(collectionUrl);
        return;
      }

      // Construct Search URL
      // We search for 'product' type specifically
      const searchUrl = `/search?q=${encodeURIComponent(term)}&type=product`;
      fetchAndRender(searchUrl);
    }

    // 3. EVENT LISTENERS

    // Search Input (Debounced)
    if (searchInput) {
      searchInput.addEventListener('input', function() {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(performSearch, 300); // Wait 300ms after typing stops
      });
    }

    // Sort Select
    if (sortSelect) {
      sortSelect.addEventListener('change', function(e) {
        // Check if we are currently searching or viewing collection
        const term = searchInput ? searchInput.value.trim() : "";

        if (term !== "") {
          // Sort within search results
          const searchUrl = `/search?q=${encodeURIComponent(term)}&type=product&sort_by=${e.target.value}`;
          fetchAndRender(searchUrl);
        } else {
          // Sort within collection
          const url = new URL(window.location.href);
          url.searchParams.set('sort_by', e.target.value);
          fetchAndRender(url.toString());
        }
      });
    }

    // Pagination Click (Delegation)
    if (productGridContainer) {
      productGridContainer.addEventListener('click', function(e) {
        const link = e.target.closest('.ajax-pagination-btn');
        if (link) {
          e.preventDefault();
          fetchAndRender(link.href);

          // Scroll to top of grid
          productGridContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }

    // Aleatorizar banners no load inicial
    shuffleBanners();
    shuffleProducts();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offset-image-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const openBtns = document.querySelectorAll('.centered-label');
    const closeBtn = document.getElementById('closeRsvpPopup');
    const popup = document.getElementById('rsvpPopup');

    if (openBtns && closeBtn && popup) {
      openBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          popup.classList.add('active');
        });
      });

      closeBtn.addEventListener('click', () => {
        popup.classList.remove('active');
      });

      // Close popup if user clicks on the overlay background
      popup.addEventListener('click', (event) => {
        if (event.target === popup) {
          popup.classList.remove('active');
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
